import Vue from 'vue'
import Vuex from 'vuex'
import configuration from './modules/configuration'
import consultationRequest from './modules/consultation_request'
import consultation from './modules/consultation'
import pastConsultation from './modules/past_consultation'
import message from './modules/message'
import loader from './modules/loader'
import toaster from './modules/toaster'
import offlineConsultation from './modules/offline_consultation'
import pastOfflineConsultation from './modules/past_offline_consultation'
import preEmpAppointmentRequest from './modules/pre_emp_appointment_request'
import appointmentRequest from './modules/appointment_request'
import notification from './modules/notification'
import preFilledMedications from './modules/pre_filled_medications'
import textField from './modules/text_field'
import healthCoach from './modules/health_coach'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    consultationRequest,
    consultation,
    configuration,
    pastConsultation,
    message,
    loader,
    toaster,
    offlineConsultation,
    pastOfflineConsultation,
    preEmpAppointmentRequest,
    appointmentRequest,
    notification,
    preFilledMedications,
    textField,
    healthCoach
  },
  actions: {
    clearAll ({ commit }) {
      commit('configuration/reset')
      commit('consultationRequest/reset')
      commit('consultation/reset')
      commit('pastConsultation/reset')
      commit('message/reset')
      commit('notification/reset')
      commit('preFilledMedications/reset')
      commit('healthCoach/reset')
    }
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js